// Deterministic visual identity only. These paths are generated from display
// metadata and must never be presented as measured chromatograms or test data.
function hashText(value) {
  let hash = 2166136261;
  for (let index = 0; index < value.length; index += 1) {
    hash ^= value.charCodeAt(index);
    hash = Math.imul(hash, 16777619);
  }
  return hash >>> 0;
}

function nextUnit(state) {
  const value = Math.imul(state.value ^ (state.value >>> 15), 1 | state.value);
  state.value = (value + Math.imul(value ^ (value >>> 7), 61 | value)) ^ value;
  return ((state.value ^ (state.value >>> 14)) >>> 0) / 4294967296;
}

export function formatStrengthLabel(strength) {
  return String(strength || 'Specification').replace(
    /(\d)\s*(mcg|mg|ml|iu)\b/gi,
    (_, amount, unit) => `${amount} ${unit.toUpperCase()}`,
  );
}

export function compoundFingerprint(product = {}) {
  const name = String(product.name || 'Compound').trim();
  const strength = String(product.strength || product.specification || '').trim();
  const key = `${name}|${strength}`.toUpperCase();
  const seed = hashText(key) || 1;
  const state = { value: seed };
  const peakCount = 3 + (seed % 2);
  const peaks = Array.from({ length: peakCount }, (_, index) => ({
    x: 62 + index * (236 / Math.max(1, peakCount - 1)) + (nextUnit(state) - 0.5) * 24,
    amplitude: 28 + nextUnit(state) * 72,
    width: 8 + nextUnit(state) * 18,
  }));
  const baseline = 126;
  const points = [];
  for (let x = 8; x <= 352; x += 4) {
    const lift = peaks.reduce((sum, peak) => {
      const distance = (x - peak.x) / peak.width;
      return sum + peak.amplitude * Math.exp(-0.5 * distance * distance);
    }, 0);
    points.push(`${x},${Math.max(18, baseline - lift).toFixed(1)}`);
  }
  return {
    path: `M${points.join(' L')}`,
    points: points.map(point => {
      const [x, y] = point.split(',').map(Number);
      return { x, y };
    }),
    signature: seed.toString(16).padStart(8, '0'),
  };
}
